import { Card, Col, Row } from 'antd'
import { BoosterProgramDetailStats } from 'Modules'

interface Props {
  stats: BoosterProgramDetailStats
}

export const BoosterDetailOverviewStats = ({ stats }: Props) => {
  const cards = [
    { title: 'Total Enrolled', value: stats.totalEnrolled },
    { title: 'Active Users', value: stats.activeEnrolledUsers },
    { title: 'Codes Issued', value: stats.codesIssued },
    { title: 'Codes Applied', value: stats.codesApplied },
  ]

  return (
    <div className="booster-detail__overview">
      <div className="booster-detail__section-title">Overview Statistics</div>
      <Row gutter={[16, 16]}>
        {cards.map((c) => (
          <Col key={c.title} xs={24} sm={12} lg={6}>
            <Card className="booster-detail__stat-card">
              <div className="booster-detail__stat-label">{c.title}</div>
              <div className="booster-detail__stat-value">
                {new Intl.NumberFormat('en-US').format(c.value)}
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  )
}
